import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

// Submenú de la pantalla actual. Una pantalla con secciones (p. ej. la ficha de un agente) lo registra y el menú lateral lo muestra
// debajo de su entrada. Forma: { parent: '/agentes', title, avatar?: { name, colors, shape, imageUrl }, items: [{ to, label, icon, badge }] }.
const Ctx = createContext({ nav: null, setNav: () => {} });

export function SubNavProvider({ children }) {
  const [nav, setNav] = useState(null);
  const value = useMemo(() => ({ nav, setNav }), [nav]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useSubNav = () => useContext(Ctx).nav;

/** Registra el submenú mientras la pantalla está montada. `nav` debe estar memorizado (useMemo) para no repintar en cada render. */
export function useRegisterSubNav(nav) {
  const { setNav } = useContext(Ctx);
  useEffect(() => { setNav(nav); }, [nav, setNav]);
  useEffect(() => () => setNav(null), [setNav]);
}
